import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-mat-paginator',
  standalone: true,
  imports: [FormsModule, MatCardModule, CommonModule, MatIconModule, MatPaginatorModule, MatButtonModule, MatSelectModule],
  templateUrl: './mat-paginator.component.html',
  styleUrl: './mat-paginator.component.scss'
})
export class MatPaginatorComponent {

  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Input() visiblePages: number[] = [];
  @Input() showEllipsis: boolean = false;

  @Output() pageChange = new EventEmitter<number>();

  goToPage(page: number) {
    this.pageChange.emit(page);
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

}
